import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var DoorOpenSVG = function DoorOpenSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M13 28H6a2 2 0 01-2-2V6a2 2 0 012-2h7v2H6v20h7zM27 3.8L16 1.2a1 1 0 00-.2 0 .8.8 0 00-.8.8v28a.8.8 0 00.8.8 1 1 0 00.2 0l11-2.6a1.3 1.3 0 001-1.2V5a1.3 1.3 0 00-1-1.2zM20 17a1 1 0 111-1 1 1 0 01-1 1z"
  }));
};
DoorOpenSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(DoorOpenSVG);